<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <OpenOrdersGrid />
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import OpenOrdersGrid from "./OpenOrdersGrid.vue";

export default {
  name: "Dashboard",
  props: [],
  components: {
    OpenOrdersGrid,
  },

  data() {
    return {};
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>